var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPintrestSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9a9 9 0 005.387 8.243c-.025-.628-.004-1.383.157-2.067l1.158-4.904s-.288-.574-.288-1.424c0-1.333.773-2.33 1.736-2.33.819 0 1.214.615 1.214 1.352 0 .823-.525 2.054-.794 3.194-.226.954.478 1.733 1.42 1.733 1.705 0 2.854-2.19 2.854-4.785 0-1.972-1.329-3.449-3.745-3.449-2.73 0-4.431 2.036-4.431 4.31 0 .784.231 1.337.593 1.766.167.196.19.275.13.501-.044.166-.143.564-.184.722-.06.228-.244.31-.45.226-1.258-.514-1.844-1.89-1.844-3.439 0-2.556 2.157-5.622 6.433-5.622 3.436 0 5.697 2.487 5.697 5.156 0 3.53-1.962 6.168-4.856 6.168-.971 0-1.885-.526-2.198-1.122 0 0-.523 2.074-.634 2.474-.19.694-.564 1.387-.905 1.928A9 9 0 100 9z",
    fill: "#0A3F46"
  })));
}

export default SvgIconPintrestSimple;